<template>
  <div class="base-textarea">
    <label
      class="body-smaller-semi-bold"
      :for="id">{{ labelText }}</label>
    <textarea
      v-model.trim="proxyModel"
      v-bind="mergedAttrs"
      class="base-textarea__input"
      @blur="($event) => $emit('blur', $event)"
      @keyup="($event) => $emit('keyup', $event)"
      @keydown="($event) => $emit('keydown', $event)"></textarea>
    <div
      v-show="errors.length"
      :id="`${id}-error`"
      class="body-smaller base-textarea__error">
      <oie-base-icon icon="warning" size="xs"></oie-base-icon>
      <span v-for="error in errors" :key="error"> {{ error }}</span>
    </div>
    <div
      v-show="description"
      :id="`${id}-description`"
      class="body-smaller"
      v-html="description">
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Date],
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: () => []
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    id() {
      return this.$attrs.id || _.uniqueId('base-textarea-')
    },
    labelText() {
      return this.required ? `${this.label}*` : this.label
    },
    mergedAttrs() {
      return {
        id: this.id,
        'aria-required': this.required ? 'true' : 'false',
        'aria-invalid': this.errors.length ? 'true' : 'false',
        'aria-describedby': `${this.id}-error ${this.id}-description`,
        ...this.$attrs
      }
    },
    proxyModel: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
// BASE
.base-textarea {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
}

.base-textarea__input {
  display: block;
  height: 10rem;
  border: 1px solid color(border-gray);
  padding: measure(quarter);
  resize: none;
}

// ERROR STYLES
.base-textarea__input[aria-invalid="true"] {
  border-color: color(text-red);
}

.base-textarea__error {
  display: flex;
  align-items: center;
  gap: measure(eighth);
  flex-wrap: wrap;
  color: color(text-red);
}

// READONLY STYLES
.base-textarea__input[readonly] {
  background-color: color(background-gray-5);
  border: 1px solid color(border-gray);
  color: color(text-gray);
}
</style>
